// Add your JS customizations here
// swiper element
const swiperEl1 = document.querySelector(".mySwiper2");

// swiper parameters
const swiperParams = {
	slidesPerView: 1,
	breakpoints: {
		450: {
			slidesPerView: 1,
		},
		640: {
			slidesPerView: 1,
		},
		1024: {
			slidesPerView: 2,
		},
	},
	on: {
		init() {
			// ...
		},
	},
};

// now we need to assign all parameters to Swiper element
Object.assign(swiperEl1, swiperParams);

// and now initialize it
swiperEl1.initialize();

function showDiv1() {
	if (window.innerWidth > 850) {
		setTimeout(function () {
			var div1 = document.querySelector(".div1");
			div1.style.display = "block";
		}, 5000);
	}
}

showDiv1();
